module.exports = __webpack_public_path__ + "img/medbg.ca7e91f4.jpg";